import loadable from "@loadable/component";

export const QuoteComparisonPage = loadable(
  () => import("./QuoteComparisonPage"),
  {
    resolveComponent: mod => mod.QuoteComparisonPage,
  },
);

// TODO: Remove these aliases once they're removed from Chopin
export const USQCPPage = QuoteComparisonPage;
export const UKQCPPage = QuoteComparisonPage;

export * from "./types";
